module.exports = __webpack_public_path__ + "static/media/junte e troque - curta a vida onde estiver.582b0cb1.png";